export default __webpack_public_path__ + "static/media/users-nav.f061d254.svg";